import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Search, X } from 'lucide-react';
import { fetchTools } from '../api/client';

export default function SearchBar({ autoFocus = false, size = 'md' }) {
  const [q, setQ] = useState('');
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const timer = useRef(null);
  const nav = useNavigate();

  useEffect(() => {
    if (!q.trim()) {
      setResults([]);
      return;
    }
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(async () => {
      try {
        const data = await fetchTools({ q, limit: 8 });
        setResults(data);
        setOpen(true);
      } catch (e) {
        setResults([]);
      }
    }, 200);
    return () => clearTimeout(timer.current);
  }, [q]);

  const submit = (e) => {
    e.preventDefault();
    if (q.trim()) {
      nav(`/category/all?q=${encodeURIComponent(q.trim())}`);
      setOpen(false);
    }
  };

  return (
    <form className={`searchbar ${size}`} onSubmit={submit} role="search">
      <Search className="searchbar-icon" size={size === 'lg' ? 20 : 14} />
      <input
        autoFocus={autoFocus}
        className="searchbar-input"
        type="text"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        onFocus={() => q && setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        placeholder='Try "create a music video", "design a logo", "AI girlfriend"...'
      />
      {q && (
        <button
          className="searchbar-clear"
          type="button"
          onClick={() => {
            setQ('');
            setResults([]);
          }}
          aria-label="Clear"
        >
          <X size={14} />
        </button>
      )}
      {open && results.length > 0 && (
        <div className="searchbar-results">
          {results.map((t) => (
            <Link key={t.id} to={`/tool/${t.slug}`} className="result-row" onMouseDown={(e) => e.preventDefault()}>
              <span className="result-name">{t.name}</span>
              <span className="result-cat">{t.primary_category}</span>
            </Link>
          ))}
          <button
            type="submit"
            className="result-row see-all"
            onMouseDown={(e) => e.preventDefault()}
          >
            See all results for &ldquo;{q}&rdquo;
          </button>
        </div>
      )}
    </form>
  );
}
